import { render, staticRenderFns } from "./dashboardLayout.vue?vue&type=template&id=6cb062a4&"
import script from "./dashboardLayout.vue?vue&type=script&lang=ts&"
export * from "./dashboardLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports